// @ts-nocheck
/* eslint-disable */
export const appCloseV224Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.70514 3.01501L3.01514 3.70501L11.3101 12L3.01514 20.295L3.70514 20.985L12.0001 12.69L20.2951 20.985L20.9851 20.295L12.6901 12L20.9851 3.70501L20.2951 3.01501L12.0001 11.31L3.70514 3.01501Z" stroke="currentColor" stroke-linecap="round"/></svg>`,
    name: 'close-v-2-24' as const
};